module.exports = __webpack_public_path__ + "img/get_success.cfcacd59.png";